export enum RouteNames {
  Resources = 'Resources'
}
